import styled from 'react-emotion'
import Colors from '../../../themes/Colors'
import { mobile, customDevice } from '../../../utils/mixins'
import {
  Typo16GainsBoroDR,
  Typo12WhiteEightDR
} from '../../../themes/Fonts/Din2014'

export const IbCricketHostingSectionContainer = styled('section')`
  background-color: ${Colors.darkTwoDefault};
  padding-top: 60px;
  ${mobile} {
    padding-top: 40px;
  }
`
export const LogoInnerContainer = styled('div')`
  padding-left: 25px;
  padding-right: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mobile} {
    padding-left: 0px;
    padding-right: 0px;
    width: 30%;
  }
`
export const Logo = styled('img')`
  padding-top: 10px;
  ${mobile} {
    padding-top: 30px;
    height: 100px;
    object-fit: cover;
  }
`
export const LogosWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  ${mobile} {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  ${customDevice(1024, 1120)} {
    justify-content: space-between;
  }
`
export const Description = styled(Typo16GainsBoroDR)`
  text-align: center;
  margin-bottom: 0px;
  ${mobile} {
    margin-top: 31px;
    font-size: 14px;
    line-height: 1.5;
  }
  span {
    color: ${Colors.pumpkinOrange};
    font-family: Nort;
    font-size: 36px;
    font-weight: bold;
    font-style: italic;
    padding-left: 10px;
    padding-right: 10px;
  }
`

export const BottomText = styled(Typo12WhiteEightDR)`
  opacity: 0.8;
  line-height: 2.33;
  letter-spacing: normal;
  text-align: right;
  color: #d9d9d9;
  padding-top: 30px;
  padding-bottom: 6px;
  ${mobile} {
    text-align: center;
    font-size: 9px;
    line-height: 3.11;
    padding-top: 40px;
    padding-bottom: 0px;
  }
`



// WEBPACK FOOTER //
// ./src/components/Events/IbCricketHostingSection/styledComponents.js